// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_eo-0";
export var fileCarousel = "_eo-2";
export var removeFileButton = "_eo-1";